import Event from "./Event";
import { EventExample } from "./progressData";

type EventsProps = {
  events: EventExample[];
  globalExpandTrigger?: { action: "expand" | "collapse", id: number } | null;
};

export default function Events({ events, globalExpandTrigger }: EventsProps) {
  return (
    <div className="w-full max-w-4xl p-4 flex flex-col">
      {events.map((event, index) => (
        <Event
          key={event.uuid}
          event={event}
          isFirst={index === 0}
          isLast={false}
          globalExpandTrigger={globalExpandTrigger}
        />
      ))}
      <div className="grid grid-cols-[80px_1fr] sm:grid-cols-[120px_1fr] gap-x-6 min-h-[80px]">
        <div className="flex flex-col items-center h-full">
          <div className="w-[2px] h-full bg-gradient-to-b from-brand-blue-200/60 to-transparent" />
        </div>
        <div className="py-6 flex items-center text-brand-neutral-500">
          <h3 className="font-medium text-white/70">Joined SolarCloud</h3>
        </div>
      </div>
    </div>
  );
}
